declare const __SDK_VERSION__: string;

export const SDK_NAME = 'evam-cloud-logger-sdk';
export const SDK_VERSION: string =
  typeof __SDK_VERSION__ === 'string' ? __SDK_VERSION__ : '0.0.0-dev';
